import types from '@/store/types';

import {
  providers,
  auth,
} from '@/plugins/firebase';

const actions = {
  [types.SIGNUP_WITH_CREDS]({
    commit,
    rootState,
  }, payload) {
    const {
      email,
      password,
    } = payload;
    return new Promise((resolve, reject) => {
      auth.createUserWithEmailAndPassword(email, password).then((res) => {
        commit(types.UPDATE_AUTH_USER, {
          ...res.user,
        }, { root: true });
        commit(types.SHOW_SNACKBAR, {
          message: rootState.messages.SIGNUP_SUCCESS,
        }, { root: true });
        resolve({
          success: true,
          message: rootState.messages.SIGNUP_SUCCESS,
        });
      }).catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, { root: true });
        reject(error);
      });
    });
  },
  [types.LOGIN_WITH_CREDS]({
    commit,
    // dispatch,
  }, payload) {
    const {
      email,
      password,
    } = payload;
    return new Promise((resolve, reject) => {
      auth.signInWithEmailAndPassword(email, password).then((res) => {
        commit(types.UPDATE_AUTH_USER, {
          ...res.user,
        }, { root: true });
        resolve({
          success: true,
        });
      }).catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, { root: true });
        reject(error);
      });
    });
  },
  [types.LOGOUT]({
    rootState,
    commit,
  }, router) {
    return new Promise((resolve, reject) => {
      auth.signOut().then(() => {
        commit(types.UPDATE_AUTH_USER, null, { root: true });
        router.push(rootState.routes.LOGIN.to);
        resolve({
          success: true,
        });
      }).catch((error) => {
        reject(error);
      });
    });
  },
  [types.LOGIN_WITH_GOOGLE]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      auth.signInWithPopup(providers.google).then((res) => {
        commit(types.UPDATE_AUTH_USER, {
          ...res.user,
        }, { root: true });
        dispatch(`db/${types.SYNC_USER}`, {
          ...res.user,
          escapeValidation: true,
        }, { root: true });
        resolve({
          success: true,
        });
      }).catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, { root: true });
        reject(error);
      });
    });
  },
  [types.LOGIN_WITH_GITHUB]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      auth.signInWithPopup(providers.github).then((res) => {
        commit(types.UPDATE_AUTH_USER, {
          ...res.user,
        }, { root: true });
        dispatch(`db/${types.SYNC_USER}`, {
          ...res.user,
          escapeValidation: true,
        }, { root: true });
        resolve({
          success: true,
        });
      }).catch((error) => {
        commit(types.SHOW_SNACKBAR, {
          color: 'error',
          message: error.message,
        }, { root: true });
        reject(error);
      });
    });
  },
};

export default actions;
